export default "__VITE_ASSET__BZEj13o2__"